import { createSlice } from '@reduxjs/toolkit';
import {
  getAllOrdersThunk,
  getClosedOrdersThunk,
  getHolidaysThunk,
  getInActiveOrdersThunk,
} from './DashboardActions';

export interface IHoliday {
  Id: number;
  calendarType: string;
  country: string;
  countryShortCode: string;
  holidayDate: string;
  holidayName: string;
  year: number;
}

export interface SwapsDashboardData {
  allOrders: any;
  inActiveOrders: any;
  closedOrders: any;
  loading: boolean;
  inActiveOrdersLoading: boolean;
  closedOrdersLoading: boolean;
  holidays: IHoliday[];
}

const initialState: SwapsDashboardData = {
  allOrders: {
    openSwaps: [],
    closedSwaps: [],
  },
  inActiveOrders: [],
  closedOrders: [],
  loading: false,
  inActiveOrdersLoading: false,
  closedOrdersLoading: false,
  holidays: [],
};

const dashboardSlice = createSlice({
  name: 'Dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllOrdersThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllOrdersThunk.fulfilled, (state, action) => {
        state.loading = false;
        const allOrders = action.payload?.data?.allOrders || { openSwaps: [], closedSwaps: [] };
        state.allOrders = {
          ...allOrders,
          closedSwaps: allOrders.closedSwaps?.map((clsSwap) => {
            return {
              ...clsSwap,
              hideActionBtns: allOrders.openSwaps?.some(
                (opnSwap) =>
                  opnSwap.orderId === clsSwap.orderId &&
                  opnSwap.basketVersion > clsSwap.basketVersion &&
                  !['CANCELLED', 'REJECTED'].includes(opnSwap.status),
              ),
            };
          }),
        };
      })
      .addCase(getAllOrdersThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getInActiveOrdersThunk.pending, (state) => {
        state.inActiveOrdersLoading = true;
      })
      .addCase(getInActiveOrdersThunk.fulfilled, (state, action) => {
        state.inActiveOrdersLoading = false;
        const inactiveOrders = action.payload?.data?.inactiveOrders ?? [];
        state.inActiveOrders = inactiveOrders;
      })
      .addCase(getInActiveOrdersThunk.rejected, (state) => {
        state.inActiveOrdersLoading = false;
        state.inActiveOrders = [];
      })
      .addCase(getClosedOrdersThunk.pending, (state) => {
        state.closedOrdersLoading = true;
      })
      .addCase(getClosedOrdersThunk.fulfilled, (state, action) => {
        state.closedOrdersLoading = false;
        const closedOrders = action.payload?.data?.closedTrades ?? [];
        state.closedOrders = closedOrders;
      })
      .addCase(getClosedOrdersThunk.rejected, (state) => {
        state.closedOrdersLoading = false;
        state.closedOrders = [];
      })
      .addCase(getHolidaysThunk.pending, (state) => {
        state.loading = true;
        state.holidays = [];
      })
      .addCase(getHolidaysThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.holidays = action.payload?.data?.allHolidaysByCurrency || [];
      })
      .addCase(getHolidaysThunk.rejected, (state) => {
        state.loading = false;
        state.holidays = [];
      });
  },
});

// export const {} = swapDashboardSlice.actions;
export default dashboardSlice.reducer;
